import { InternalTrailerType } from 'src/types/enums';

export const INTERNAL_TRAILER_TYPE_OPTIONS = [
  { key: InternalTrailerType.Tautliner, name: 'Tautliner' },
  { key: InternalTrailerType.Mega, name: 'Mega' },
] as const;

export const INTERNAL_TRAILER_TYPE_LABELS: Record<InternalTrailerType, string> = {
  [InternalTrailerType.Tautliner]: 'Tautliner',
  [InternalTrailerType.Mega]: 'Mega',
};
